// src/pages/hospitals/index.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

import LayoutShell from "@/components/ui/LayoutShell.jsx";
import TopBarCenter from "@/sot/primitives/TopBarCenter.jsx";
import HospitalResultCard from "@/components/hospital/HospitalResultCard.jsx";
import HospitalsFilterSheet from "@/pages/hospitals/HospitalsFilterSheet.jsx";

// Mock data for now (later we can hydrate from /data/health_facilities_sadc.csv)
const MOCK_HOSPITALS = [
  {
    id: "kalafhi",
    name: "Kalafhi Medical Center",
    image: "/assets/images/hospital_filters/hospital-01.png",
    address: "8WJJ+2MR, Kgaladua, Gaborone, Botswana",
    distance: "5 km away",
    rating: null,
    isFavorite: true,
  },
  {
    id: "sidilega",
    name: "Sidilega Private Hospital",
    image: "/assets/images/hospital_filters/hospital-02.jpg",
    address: "59932 Basotho Dr, Gaborone, Botswana",
    distance: "6 km away",
    rating: null,
    isFavorite: false,
  },
  {
    id: "riverside",
    name: "Riverside Hospital",
    image: "/assets/images/hospital_filters/hospital-03.jpg",
    address: "424 Baines Ave, Francistown, Botswana",
    distance: "7 km away",
    rating: null,
    isFavorite: false,
  },
  {
    id: "lenmed",
    name: "Lenmed Bokamoso Private Hospital",
    image: "/assets/images/hospital_filters/hospital-04.jpg",
    address: "Block 1 Mmopane, Gaborone, Botswana",
    distance: "7.4 km away",
    rating: null,
    isFavorite: true,
  },
  {
    id: "multicare",
    name: "MultiCare Medical Center",
    image: "/assets/images/hospital_filters/hospital-05.jpg",
    address: "3rd Avenue, Nairobi, Kenya",
    distance: "7 km away",
    rating: null,
    isFavorite: false,
  },
  {
    id: "santa-isabel",
    name: "Santa Isabel Clinic",
    image: "/assets/images/hospital_filters/hospital.png",
    address: "Idi-Araba Road, Surulere, Nigeria",
    distance: "7.4 km away",
    rating: null,
    isFavorite: false,
  },
];

export default function HospitalsPage() {
  const nav = useNavigate();

  // Filter state mirrors HospitalsFilterSheet: { data: [...], payment: [...] }
  const [filters, setFilters] = React.useState({
    data: ["near-you"],
    payment: [],
  });

  const [isFilterOpen, setIsFilterOpen] = React.useState(false);

  const activeFilterCount = React.useMemo(() => {
    const d = filters.data?.length || 0;
    const p = filters.payment?.length || 0;
    return d + p;
  }, [filters]);

  return (
    <LayoutShell>
      <div className="afrimed-rail afrimed-rail--comfortable px-4 pt-4 pb-24">
        {/* Top bar – Hospitals */}
        <header className="mb-4">
          <TopBarCenter
            title="Hospitals"
            close
            onBack={() => nav(-1)}
          />
        </header>

        {/* Subtitle row – text left, Filter right */}
        <section className="mb-4 flex items-center justify-between">
          <h2 className="text-title-medium text-on-surface-var">
            Hospitals near you
          </h2>

          <button
            type="button"
            onClick={() => setIsFilterOpen(true)}
            className="inline-flex items-center gap-1 text-body-medium text-primary"
          >
            <img
              src="/icons/patient/filter.svg"
              alt=""
              className="h-[18px] w-[18px]"
              draggable="false"
            />
            <span>
              Filter{activeFilterCount > 0 ? ` · ${activeFilterCount}` : ""}
            </span>
          </button>
        </section>

        {/* Results list – stacked 68px-ish rows */}
        <section className="space-y-3">
          {MOCK_HOSPITALS.map((h) => (
            <HospitalResultCard key={h.id} hospital={h} />
          ))}
        </section>
      </div>

      {/* Filter sheet */}
      <HospitalsFilterSheet
        open={isFilterOpen}
        value={filters}
        onChange={setFilters}
        onClose={() => setIsFilterOpen(false)}
      />
    </LayoutShell>
  );
}
